<template>
  <nav class="ui left fixed vertical menu fuzzy-list">
    <Spinny :promise="manufacturersPromise" />
    <Placy
      v-if="!items.length"
      :promise="manufacturersPromise"
      :empty-message="$t('NO_THING_YET', { thing: $tc('MANUFACTURER', 2) })"
      :error-message="$t('ERR', { action: $t('READ', { thing: $tc('MANUFACTURER', 2) }) })"
    />

    <!-- Search -->
    <div class="item" v-if="items.length > 10">
      <div class="ui icon input">
        <input
          type="text"
          :placeholder="$t('SEARCH')"
          v-model="searchTerm"
          autocomplete="off"
          @keydown.esc="searchTerm = ''"
        />
        <i class="search icon"></i>
      </div>
    </div>

    <router-link class="item" :to="{ name: 'new-manufacturer' }">
      <i class="plus icon"></i>
      <strong>{{ $t('NEW', { thing: $tc('MANUFACTURER', 1) }) }}</strong>
    </router-link>

    <router-link
      class="item"
      :active-class="'active'"
      :to="{ name: 'manufacturer', params: { manufacturerId: manufacturer.original.id } }"
      v-for="manufacturer in filteredItems"
      :key="manufacturer.original.id"
    >
      <div class="text ellipsis" :title="manufacturer.original.name" v-html="manufacturer.string" />
    </router-link>
  </nav>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';

nav {
  overflow-y: scroll;
}
</style>

<script>
// @flow
import { Spinny, Placy } from 'ui'
import { Manufacturer } from 'services'
import FuzzyFilterer from '../Mixins/FuzzyFilterer'

export default {
  name: 'manufacturer-list',
  components: { Spinny, Placy },
  mixins: [FuzzyFilterer],

  data() {
    return {
      manufacturersPromise: null
    }
  },

  computed: {
    items() {
      return this.$store.state.manufacturer.items
    }
  },

  created() {
    this.manufacturersPromise = Manufacturer.readAllManufacturers()
  }
}
</script>
